import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

interface IProps {
    seo_description?: string;
}

export const VendorListSeoDescription = (props: IProps) => {
    return <div css={[descriptionHolder, mb(4)]} dangerouslySetInnerHTML={{__html: `${props.seo_description}`}} />;
};

const descriptionHolder = (theme: Theme) => css`
    background-color: #fff;
    ${p(3)};
    ${borderRadius(1)};
    ${getTextVariantStyleFor("body_copy_1")(theme)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, p} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

interface IProps {
    seo_description?: string;
}

export const VendorListSeoDescription = (props: IProps) => {
    return <div css={[descriptionHolder, mb(4)]} dangerouslySetInnerHTML={{__html: `${props.seo_description}`}} />;
};

const descriptionHolder = (theme: Theme) => css`
    background-color: #fff;
    ${p(3)};
    ${borderRadius(1)};
    ${getTextVariantStyleFor("body_copy_1")(theme)};
`;
